/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Long_Tiny_Gibbon_ProsperInputs */

const fr_long_tiny_gibbon_prosper = /** @type {(inputs: Long_Tiny_Gibbon_ProsperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Records personnels`)
};

/**

* @param {Long_Tiny_Gibbon_ProsperInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const long_tiny_gibbon_prosper = /** @type {((inputs?: Long_Tiny_Gibbon_ProsperInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Long_Tiny_Gibbon_ProsperInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_long_tiny_gibbon_prosper(inputs)
});